import type { IntegrationCapabilityReadiness } from "@/lib/api/integrations";

export const isReady = (capability: IntegrationCapabilityReadiness) => capability.status === "ready" && capability.action_available;
